import styles from './styles.module.scss'
import IconPhone from '/public/icons/icon-phone.svg'
import Button from '../Button'
import { useResponsive } from '../../../providers/ResponsiveContext'
import { useState, useRef, useEffect } from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'

const Hamburger = ({
  trigger,
  children,
  setMenuOpen,
  changeState,
  translations
}) => {
  const { isSmallMobile } = useResponsive()
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)
  const body = typeof window !== 'undefined' && document.querySelector('body')
  const wrapperRef = useRef(null)
  const router = useRouter()

  // Handle body class for mobile
  useEffect(() => {
    if (!isSmallMobile || !body) return

    if (open) {
      body.classList.add('modal-open')
    } else {
      body.classList.remove('modal-open')
    }

    return () => {
      body.classList.remove('modal-open')
    }
  }, [open, isSmallMobile, body])

  // Handle opening and closing of the menu
  const handleOpen = () => {
    // For opening
    if (!open) {
      // First mount the content without the open class
      setMounted(true)

      // Use requestAnimationFrame to ensure DOM update before setting open state
      // This creates a sequence that allows the entry animation to work
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setOpen(true)
          setMenuOpen && setMenuOpen(true)
        })
      })
    }
    // For closing
    else {
      setOpen(false)
      setMenuOpen && setMenuOpen(false)

      // Wait for transition to complete before unmounting
      const transitionDuration = 300 // Match with your CSS transition duration
      setTimeout(() => {
        setMounted(false)
      }, transitionDuration)
    }
  }

  // Click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        open
      ) {
        handleOpen()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  // Handle route changes
  useEffect(() => {
    return () => {
      body && body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    if (open) {
      setOpen(false)
      setMenuOpen && setMenuOpen(false)

      const transitionDuration = 300 // Match this with your CSS transition duration
      setTimeout(() => {
        setMounted(false)
      }, transitionDuration)
    }
  }, [router.asPath])

  // Handle external state changes
  useEffect(() => {
    if (changeState === true && !open) {
      setMounted(true) // Ensure content is mounted before animation

      // Use requestAnimationFrame for smoother animation
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setOpen(true)
          setMenuOpen && setMenuOpen(true)
        })
      })
    }
  }, [changeState])

  return (
    <div
      ref={wrapperRef}
      className={classNames(styles.menu, open && styles.isOpen)}
    >
      <div onClick={handleOpen} className={styles.menu__trigger}>
        {trigger}
      </div>

      {(mounted || open) && (
        <div className={styles.menu__content}>
          <div className={styles.menu__overflow}>{children}</div>

          {isSmallMobile && (
            <div className={styles.menu__footer}>
              <Button
                disabled={router.asPath === '/contact'}
                href="/contact"
                variant={['full-width']}
              >
                {translations.getInTouch[router.locale]}
              </Button>

              <Button
                prepend={<IconPhone />}
                variant={['full-width']}
                arrow={false}
                rel="nofollow"
                href="tel: +1 213-805-0840"
              >
                {translations.callUs[router.locale]}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Hamburger
